export default [
  {
    name: "Contacts",
    path: "/contacts",
    component: () => import('../../views/contacts/TheContactList.vue'),
    meta: {
      title: 'main-menu.contacts',
      requiresAuth: true,
      access_control: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_BASIC', 'ROLE_AGENT'],
      isInMenu: true,
      type: 'link',
      icon: 'fas fa-address-book',
      order: 4,
    },
  },
  {
    name: "EditContact",
    path: "/contacts/:id/edit",
    component: () => import('../../views/contacts/TheEditContactForm.vue'),
    props: true,
    meta: {
      requiresAuth: true,
      access_control: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_BASIC', 'ROLE_AGENT'],
    }
  },
  {
    name: "NewContact",
    path: "/contacts/new",
    component: () => import('../../views/contacts/TheNewContactForm.vue'),
    props: true,
    meta: {
      requiresAuth: true,
      access_control: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_BASIC', 'ROLE_AGENT'],
    },
  }
]
